import React from 'react';
import { createRoot } from 'react-dom/client';
import RevenueCalculator from 'components/RevenueCalculator';

function mountCalculator(containerId) {
  const container = document.getElementById(containerId);
  if (container) {
    const num = (val, fallback) => { const n = parseFloat(val); return isNaN(n) ? fallback : n; };
    const feeLabels = JSON.parse(container.dataset.feeLabels || '{}');
    const props = {
      platformFeeInvited: num(container.dataset.platformFeeInvited, 0.00),
      platformFeePlatform: num(container.dataset.platformFeePlatform, 0.15),
      defaultOwnerCommissionInvited: num(container.dataset.defaultOwnerCommissionInvited, 0.10),
      defaultOwnerCommissionPlatform: num(container.dataset.defaultOwnerCommissionPlatform, 0.05),
      serviceFeeRate: num(container.dataset.serviceFeeRate, 0.10),
      variant: container.dataset.variant || 'full',
      feeLabels
    };

    const root = createRoot(container);
    root.render(<RevenueCalculator {...props} />);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  mountCalculator('revenue-calculator');
  mountCalculator('revenue-calculator-homepage');
  mountCalculator('revenue-calculator-for-teachers');
});
